import React, {Component} from 'react';
import CheckboxButton from "../../comum/components/CheckboxButton";
import { Row } from "reactstrap";
import { observer } from "mobx-react/index";

@observer
export default class FiltroVisualizacaoBtn extends Component{

    constructor(props){
        super(props);
    }

    isAtivo(val, arr){
        return arr.indexOf(val)!==-1;
    }

    render(){
        return(
            <div className="secao">
                <h2>{this.props.titulo}</h2>
                <Row>
                    <div className="container checkbox-botao-container">
                        <ul className="ks-cboxtags">
                            { this.props.itens && this.props.itens.map((sit, i) => (
                                <CheckboxButton key={i} index={sit} valor={sit} ativo={ this.isAtivo(sit, this.props.itensAtivos)} onClick={ this.props.onClickItem } />
                            ))}
                        </ul>
                    </div>
                </Row>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FiltroVisualizacaoBtn.js